/**
 * Web Mercator lng/lat → world-pixel projection, shared by the map's WebGL
 * overlays (label decluttering, marker collision offsetting).
 */
export function toWorldPixel(lng: number, lat: number, zoom: number): [number, number] {
  const scale = 256 * 2 ** zoom
  const x = ((lng + 180) / 360) * scale
  const sinLat = Math.sin((lat * Math.PI) / 180)
  const y = (0.5 - Math.log((1 + sinLat) / (1 - sinLat)) / (4 * Math.PI)) * scale
  return [x, y]
}
